export default __webpack_public_path__ + "static/media/cafe.9022913d.svg";